import styled from "styled-components";
import { capitalizeFirstLetter } from "../../utils/formatters";
import StatusIndicator, { TStatusIndicatorProps } from "./StatusIndicator";

export type THistoryItem = {
  title: string;
  author: string;
  date: string;
  color: TStatusIndicatorProps["status"];
};

type THistoryProps = {
  title: string;
  items: THistoryItem[];
};

const Container = styled.div`
  width: 320px;
  height: fit-content;

  border-radius: 8px;
  border: 1px solid var(--color-light-200);
  box-shadow: 0px 1px 3px 0px hsla(0, 0%, 56%, 0.15);

  ul {
    padding-inline-start: 36px;
  }
`;

const TitleContainer = styled.div`
  width: "100%";
  padding: 12px 16px;

  border-radius: 8px;
  border-bottom: 1px solid var(--color-light-200);

  box-shadow: 0px 1px 3px 0px hsla(0, 0%, 56%, 0.15);

  h3 {
    font-family: var(--font-title-bold);
    font-size: 16px;
    color: var(--color-text-title);
  }
`;

const HistoryListItem = styled.li`
  position: relative;

  h4 {
    font-family: var(--font-paragraph-bold);
    font-size: 14px;
    color: var(--color-text-title);
  }

  time,
  p,
  p span {
    font-family: var(--font-paragraph-default);
    font-size: 12px;
    color: var(--color-text-labels);
  }

  p span {
    color: var(--color-text-paragraph);
  }

  .status-indicator {
    position: absolute;
    bottom: 18px;
    left: -24px;
  }

  .status-tail {
    height: 52px;
    width: 1px;
    border-left: 1px solid var(--color-light-200);
    position: absolute;
    left: -19px;
    top: 32px;
  }
`;

const History: React.FC<THistoryProps> = ({ title, items }) => {
  return (
    <Container>
      <TitleContainer>
        <h3>{title}</h3>
      </TitleContainer>
      <ul>
        {items.map((item, index) => (
          <HistoryListItem key={index}>
            <StatusIndicator
              className="status-indicator"
              status={item.color as "green" | "orange" | "red" | "blue"}
            />
            {index !== items.length - 1 && (
              <span className="status-tail"></span>
            )}

            <div style={{ marginTop: 12 }}>
              <time>{item.date}</time>
              <h4>{capitalizeFirstLetter(item.title)}</h4>
              <p>
                Por <span>{item.author}</span>
              </p>
            </div>
          </HistoryListItem>
        ))}
      </ul>
    </Container>
  );
};

export default History;
